import { IController } from 'angular';
import * as _ from 'lodash';
/* tslint:disable-next-line:max-line-length */
import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';
import { RegentsExam } from '../../../../../ng2/shared/constants/regents.constant';
import { StudentPanelPersistance } from '../../../../../ng2/shared/services/student-panel-persistance/student-panel-persistance.service';
import { IRegentsTranscript } from '../../../../../ng2/shared/typings/interfaces/student.interface';
import { ImStudentRegents } from './../../../../shared/static-models/im-models/im-student-regents';

export class StudentFullExamHistoryPanelCtrl implements IController {
  static $inject = ['$scope', 'UtilitiesService', 'StudentPanelPersistance', 'ImStudentRegents'];

  // bindings
  private student;

  // local
  private title;
  private tableRows;
  private tableRowsForTable1;
  private tableRowsForTable2;
  private sortBy;

  constructor(
    private $scope,
    private UtilitiesService: UtilitiesService,
    private StudentPanelPersistance: StudentPanelPersistance,
    private imStudentRegents: ImStudentRegents,
  ) {}

  $onInit() {
    this.title = 'Full Exam History';

    const regentsTranscriptCopy = _.cloneDeep(this.student.regentsDetails.transcript);

    this.tableRows = _.map(regentsTranscriptCopy, (examOnTranscript: IRegentsTranscript) => {
      // TODO: key should be on schema
      const regentsExam = _.find(RegentsExam, { shortName: examOnTranscript.examName });
      const regentsExamKey = regentsExam ? regentsExam.key : null;
      const regentsExamSortOrder = regentsExam ? regentsExam.order : null;

      let row: any = _.assign({}, examOnTranscript);
      row.regentsExamKey = regentsExamKey;
      row.regentsExamSortOrder = regentsExamSortOrder || 999;
      // css class for exam score
      // tslint:disable-next-line:max-line-length
      row.cssClass = this.getRowCssClass(
        this.imStudentRegents.regentsExamPassedStatusBasedOnScoreAndDiplomaType(
          this.student,
          regentsExamKey,
          examOnTranscript.mark.num,
        ),
      );
      row.idx = this.UtilitiesService.createV4Uuid();
      const month = examOnTranscript.month;
      const monthVal = month === 'Jan' ? 1 : month === 'June' ? 2 : month === 'Aug' ? 3 : 0;
      row.admin = examOnTranscript.schoolYear + monthVal;
      return row;
    });

    // sort table by exam on init
    this.sortBy = this.StudentPanelPersistance.setInitialSort({
      sortKey: 'fullExamHistorySort',
      sortOptions: {
        sortByExamCode: this.sortByExamCode.bind(this),
        sortByAdminDate: this.sortByAdminDate.bind(this),
        default: 'sortByExamCode',
      },
    });

    this.tableRowsForTable1 = _.slice(this.tableRows, 0, Math.ceil(this.tableRows.length / 2));
    this.tableRowsForTable2 = _.slice(this.tableRows, Math.ceil(this.tableRows.length / 2), this.tableRows.length);

    // update css for each exam on changes to student.gradPlanningDetails.plannedDiplomaType
    this.$scope.$watch(
      () => {
        return this.$scope.$ctrl.student.gradPlanningDetails;
      },
      newVal => {
        _.forEach(this.tableRows, (row: any) => {
          // tslint:disable-next-line:max-line-length
          row.cssClass = this.getRowCssClass(
            this.imStudentRegents.regentsExamPassedStatusBasedOnScoreAndDiplomaType(
              this.student,
              row.regentsExamKey,
              row.mark.num,
              newVal.plannedDiplomaType,
            ),
          );
        });
      },
      true,
    );
  }

  // methods

  // NG-CHANGE sort
  sort() {
    const sortKey = 'fullExamHistorySort';
    const sortByExamCode = 'sortByExamCode';
    const sortByAdminDate = 'sortByAdminDate';

    if (this.sortBy === sortByExamCode) {
      this.StudentPanelPersistance.updateAndPersistSort(sortKey, sortByExamCode);
      return this.sortByExamCode();
    }

    if (this.sortBy === sortByAdminDate) {
      this.StudentPanelPersistance.updateAndPersistSort(sortKey, sortByAdminDate);
      return this.sortByAdminDate();
    }
  }

  // ASCENDING ORDER

  sortByExamCode() {
    this.tableRows.sort((a, b) => {
      if (a.regentsExamSortOrder > b.regentsExamSortOrder) return 1;
      if (a.regentsExamSortOrder === b.regentsExamSortOrder) return this.compareAdminDate(a.admin, b.admin);
      return -1;
    });

    this.tableRowsForTable1 = _.slice(this.tableRows, 0, Math.ceil(this.tableRows.length / 2));
    this.tableRowsForTable2 = _.slice(this.tableRows, Math.ceil(this.tableRows.length / 2), this.tableRows.length);
  }

  // DESCENDING ORDER
  sortByAdminDate() {
    this.tableRows.sort((a, b) => {
      return this.compareAdminDate(a.admin, b.admin);
    });
    this.tableRowsForTable1 = _.slice(this.tableRows, 0, Math.ceil(this.tableRows.length / 2));
    this.tableRowsForTable2 = _.slice(this.tableRows, Math.ceil(this.tableRows.length / 2), this.tableRows.length);
  }

  compareAdminDate(adminDateA, adminDateB) {
    if (adminDateA > adminDateB) {
      return 1;
    }
    return -1;
  }

  getRowCssClass(examScoreStatus) {
    if (examScoreStatus.collegeReady) {
      return 'college-ready';
    }

    if (examScoreStatus.passed) {
      return 'passed';
    }

    if (examScoreStatus.passed === false) {
      return 'not-passed';
    }

    return '';
  }
}

angular.module('nv.singleStudent').controller('StudentFullExamHistoryPanelCtrl', StudentFullExamHistoryPanelCtrl);
